import {useEffect, useState} from 'react';
import {onConnectionChange} from '../api';

export default function ConnectionBanner() {
  const [offline, setOffline] = useState(false);

  useEffect(() => onConnectionChange(setOffline), []);

  if (!offline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white text-center py-2 text-sm font-medium shadow-lg">
      Unable to connect to the server. Please check your connection or try again later.
    </div>
  );
}
